module.exports = __webpack_public_path__ + "img/91.69f55bf4.jpg";